export const callOrReturn = (funcOrValue: any, ...args: any[]) =>
  typeof funcOrValue === 'function' ? funcOrValue(...args) : funcOrValue;
